import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		let $firstPlane = $(
			'.inner-content-wrap .coastal-text-media-block:nth-child(2) .white-line svg'
		)
		if ($firstPlane.length) {
			// const anim = gsap.to('.inner-content-wrap .coastal-text-media-block:nth-child(2) .white-line svg', {
			// 	y: 100,
			// 	duration: 1,
			// 	ease: "power2.inOut",
			// 	paused: true
			// });
			// const playST = ScrollTrigger.create({
			// 	trigger:'.Highlight',
			// 	start:'top 80%',
			// 	onEnter: () => anim.play()
			// });

			// const resetST = ScrollTrigger.create({
			// 	trigger:'.Highlight',
			// 	onLeaveBack: () => anim.pause(0)
			// });
			gsap.fromTo(
				'.inner-content-wrap .coastal-text-media-block:nth-child(2) .white-line svg',
				{
					y: -50,
				},
				{
					scrollTrigger: {
						trigger:
							'.inner-content-wrap .coastal-text-media-block:nth-child(2) .white-line svg',
						toggleActions: 'restart pause resume none',
						// markers: true,
					},
					duration: 0.5,
					y: 100,
				}
			)
		}

		let $secondPlane = $(
			'.inner-content-wrap .coastal-text-media-block:nth-child(3) .white-line svg'
		)
		if ($secondPlane.length) {
			gsap.fromTo(
				'.inner-content-wrap .coastal-text-media-block:nth-child(3) .white-line svg',
				{
					x: 0,
				},
				{
					scrollTrigger:
						'.inner-content-wrap .coastal-text-media-block:nth-child(3) .white-line svg',
					duration: 0.5,
					x: -150,
					opacity: 1,
				}
			)
		}
		let $thirdPlane = $(
			'.inner-content-wrap .coastal-text-media-block:nth-child(4) .white-line svg'
		)
		if ($thirdPlane.length) {
			gsap.fromTo(
				'.inner-content-wrap .coastal-text-media-block:nth-child(4) .white-line svg',
				{
					x: -150,
				},
				{
					scrollTrigger:
						'.inner-content-wrap .coastal-text-media-block:nth-child(4) .white-line svg',
					duration: 0.5,
					x: 0,
					opacity: 1,
				}
			)
		}
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
